export const enTranslation = {
      common: {
        loading: "Loading",
        loadingWithDots: "Loading...",
        error: "An error occurred",
        save: "Save",
        cancel: "Cancel",
        search: "Search",
        logout: "Log out",
        close: "Close",
        back: "Back",
        register: "Register",
        update: "Update",
        edit: "Edit",
        delete: "Delete",
        stop: "Stop",
        restore: "Reactivate",
        operation: "Operation",
        downloadCsv: "Download CSV",
        uploadCsv: "Upload CSV",
        csvUploading: "Uploading CSV...",
        uploading: "Uploading...",
        processing: "Processing...",
        noData: "No data",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        all: "All",
      },
      csvImportModal: {
        defaultButton: "Import CSV",
        guideButton: "View instructions",
        description: "Download the template, review the instructions, then select a CSV file.",
        templateDownload: "Download template",
        selectAndImport: "Select CSV and import",
        guideTitle: "Instructions",
        guideFetchFailed: "Failed to load CSV instructions.",
        guideFetchError: "Failed to fetch CSV instructions.",
      },
      language: {
        japanese: "Japanese",
        english: "English",
        switchLabel: "Display language",
      },
      auth: {
        loginTitle: "Log in",
        email: "Email",
        password: "Password",
        loginNow: "Log in",
        forgotPassword: "Forgot your password?",
        emailRequired: "Enter your email address.",
        emailInvalid: "Enter a valid email address.",
        passwordRequired: "Enter your password.",
        invalidCredentials: "The email address or password is incorrect.",
        loginFailed: "Login failed.",
      },
      navigation: {
        companyManagement: "Company management",
        companyList: "Companies",
        itemList: "Items",
        deviceManagement: "Device management",
        nameMatchingManagement: "Name matching",
        reportLayoutManagement: "Report layouts",
        apiIntegration: "API integration",
        externalApiKeys: "External API keys",
        contractPlanManagement: "Contract plans",
        companyPlanAssignment: "Company plan assignments",
        backfill: "Backfill",
        apiMonitoringDashboard: "API monitoring dashboard",
      },
      externalApiKey: {
        title: "External API key management",
        tabs: {
          keys: "Keys",
          events: "Event history",
        },
        keyCount: "API keys",
        issue: "Create API key",
        issueOk: "Create",
        rotate: "Rotate",
        revoke: "Revoke",
        revoked: "Revoked",
        revokeFailed: "Failed to revoke the API key",
        revokeSucceeded: "API key revoked",
        rotateConfirmTitle: "Rotate this API key?",
        rotateConfirmContent: "Rotate \"{{name}}\". A new key will be issued and the old key will be revoked after a 7-day grace period.",
        planLimitReached: "The plan limit has been reached. Upgrade to Premium or configure a company override.",
        issuedTitle: "API key created",
        fullKeyWarning: "This key is shown only on this screen. Share it with the customer through a secure channel (it cannot be shown again).",
        issuedNameHelp: "Label: {{name}} (Copy it or download the CSV and store it securely.)",
        revokeTitle: "Revoke API key",
        revokeContent: "Revoke \"{{name}}\" immediately. After revocation, this key can no longer be used for authentication.",
        revokeReasonOptional: "Revocation reason (optional)",
        validation: {
          nameRequired: "Usage label (name) is required",
        },
        columns: {
          name: "Usage label",
          keyPrefix: "Key prefix",
          expiresAt: "Expires at",
          lastUsedAt: "Last used",
          createdAt: "Created at",
          revokedAt: "Revoked at",
        },
        filters: {
          activeOnly: "Active only",
          revokedOnly: "Revoked only",
        },
        fields: {
          nameRequired: "Usage label (name) *",
          expiresAtOptional: "Expiration (optional)",
          allowedIpsOptional: "Allowed IPs (optional, comma-separated)",
        },
        placeholders: {
          name: "Example: TSI production",
          noExpiry: "No expiration",
          allowedIps: "Example: 203.0.113.0/24,198.51.100.42",
          revokeReason: "Example: Suspected customer-side leak",
        },
        events: {
          retentionNote: "Operation history is retained for 5 years for audit purposes.",
          noCompany: "Select a company to show operation history.",
          apiKeyIdOptional: "API key ID (optional)",
          apiKeyIdPlaceholder: "Example: 12",
          eventTypeOptional: "Type (optional)",
          fromOptional: "From (optional)",
          toOptional: "To (optional)",
          startDateTime: "Start date and time",
          endDateTime: "End date and time",
          csvExport: "Export CSV",
          csvExportFailed: "CSV export failed",
          csvDownloaded: "CSV downloaded",
          footerNote: "CSV export is generated on the server using the current filters and downloaded as-is.",
          columns: {
            occurredAt: "Occurred at",
            type: "Type",
            key: "Key",
            keyPrefix: "Key prefix",
            actor: "Actor",
            reason: "Reason",
          },
          types: {
            issued: "Issued",
            rotated: "Rotated",
            revoked: "Revoked",
            expires_extended: "Expiration extended",
            allowed_ips_changed: "Allowed IPs changed",
          },
        },
      },
      contractPlan: {
        title: "Contract plan management",
        propagationNote: "Limit changes propagate to existing companies within 60 seconds at most (cache reflection may be delayed).",
        listNote: "Showing all active and inactive plans.",
        createButton: "Create plan",
        createTitle: "Create contract plan",
        editTitle: "Edit contract plan",
        editTitleWithCode: "Edit contract plan: {{code}}",
        createOk: "Create",
        updateOk: "Update",
        created: "Contract plan created",
        updated: "Contract plan updated",
        deactivated: "Contract plan deactivated",
        deactivate: "Deactivate",
        deactivateConfirmTitle: "Deactivate \"{{name}}\"?",
        deactivateConfirmContent: "After deactivation, this plan cannot be assigned to new companies. Companies already assigned to this plan are not affected (their effective limits are preserved).",
        editWarning: "This update overwrites every field. Review all visible fields before saving (omitted fields return to their defaults).",
        codeReadOnly: "code cannot be changed.",
        allowed: "Allowed",
        notAllowed: "Not allowed",
        fields: {
          code: "Code (code)",
          name: "Plan name (name)",
          description: "Description (optional)",
          rateLimitPerMinute: "Rate limit/min",
          rateLimitPerHour: "Rate limit/hour",
          rateLimitImagePerMinute: "Image rate limit/min",
          maxPageSize: "Max page size",
          maxApiKeysPerCompany: "Max API keys/company",
          maxRedeliveriesPerDay: "Max redeliveries/day",
          allowIpRestriction: "Allow IP restriction",
        },
        validation: {
          codeRequired: "code is required",
          nameRequired: "name is required",
          required: "Required",
          max64: "Up to 64 characters",
          max255: "Up to 255 characters",
        },
        placeholders: {
          code: "Example: premium",
          name: "Example: Premium plan",
          description: "Plan description",
        },
        columns: {
          code: "Code",
          name: "Plan name",
          description: "Description",
          rateMinute: "Rate/min",
          rateHour: "Rate/hour",
          imageRateMinute: "Image rate/min",
          maxApiKeys: "Max API keys",
          ipRestrictionAllowed: "IP restriction",
        },
      },
      companyPlan: {
        title: "Company plan assignment",
        overrideNote: "Overrides are company-specific adjustments. Blank fields use the plan value as-is.",
        applySucceeded: "Plan applied",
        selectCompanyError: "Select a company",
        selectPlanError: "Select the plan to apply",
        confirmTitle: "Apply this plan?",
        confirmContent: "Apply \"{{planLabel}}\" to the selected company. Effective limits such as rate limits and API key counts change immediately and may affect customer usage. Blank overrides use the plan values. Continue?",
        currentAssignment: "Current assignment",
        assignedPlan: "Assigned plan",
        unassigned: "Unassigned",
        effectiveLimits: "Effective limits",
        planChangeTitle: "Plan change / override settings",
        applyPlanRequired: "Plan to apply *",
        planSelectPlaceholder: "Select a plan",
        blankUsesPlanValue: "Blank = plan value",
        usePlanValue: "Use plan value",
        apply: "Apply",
        allowed: "Allowed",
        notAllowed: "Not allowed",
        fields: {
          rateLimitPerMinute: "Rate limit/min",
          rateLimitPerHour: "Rate limit/hour",
          rateLimitImagePerMinute: "Image rate limit/min",
          maxPageSize: "Max page size",
          maxApiKeysPerCompany: "Max API keys/company",
          maxRedeliveriesPerDay: "Max redeliveries/day",
        },
      },
      backfill: {
        title: "Backfill",
        description: "Re-enqueue past data to the external integration queue (such as Webhooks). Progress is refreshed automatically after submission.",
        selectCompanyError: "Select a company",
        selectApiKeyError: "Select the target API key",
        submitted: "Backfill submitted",
        labels: {
          company: "Company *",
          apiKey: "Target API key *",
          from: "From (optional)",
          to: "To (optional)",
        },
        placeholders: {
          selectCompanyFirst: "Select a company first",
          selectApiKey: "Select an API key",
          startDateTime: "Start date and time",
          endDateTime: "End date and time",
        },
        unsupportedNotice: "Previewing the planned item count, specifying rate_per_minute, and canceling jobs are not supported by the server yet (follow-up for #469).",
        submit: "Submit backfill",
        jobTitle: "Submitted job",
        job: {
          id: "Job ID",
          total: "Target count (total)",
          enqueued: "Enqueued",
          error: "Error",
          createdAt: "Created at",
        },
        pollingMessage: "Automatically refreshing progress every {{seconds}} seconds...",
      },
      apiMonitoring: {
        title: "API monitoring dashboard",
        deferredTitle: "Current scope",
        deferredNotice: "Because the #457 aggregation batch is not implemented, this screen does not support: 5-minute granularity / anomaly alerts (N times in the last 5 minutes) / sample_id trace search / cross-company filters / row-level raw log CSV. This screen shows only hour/day aggregates per API key.",
        selectApiKeyWarning: "Select an API key",
        noStatsWarning: "There are no statistics to export",
        placeholders: {
          selectApiKey: "Select an API key",
          selectCompanyFirst: "Select a company first",
          noActiveApiKeys: "No active API keys",
          startDate: "Start date",
          endDate: "End date",
        },
        granularity: {
          hour: "1 hour",
          day: "1 day",
        },
        presets: {
          last24Hours: "Last 24 hours",
          last30Days: "Last 30 days",
        },
        show: "Show",
        csvExport: "Export CSV",
        emptySelect: "Select a company and API key to show statistics",
        emptyNoData: "No statistics are available for the selected period",
        cards: {
          calls: "Calls over time",
          errorRate: "Error rate over time ((4xx+5xx)/total %)",
          rateLimited: "Rate limit hits",
          statusBreakdown: "Status class breakdown (stacked)",
        },
        series: {
          calls: "Calls",
          errorRate: "Error rate",
          rateLimited: "Rate limit hits",
        },
        footerNote: "CSV contains the retrieved aggregate values (bucket x status_class). It is not raw log rows (raw log CSV is not supported until #457).",
      },
      company: {
        companyInfo: "Company information",
        detailPage: "Company details",
        companyName: "Company name",
        address: "Address",
        phoneNumber: "Phone number",
        phoneNumberNoHyphen: "Phone number (no hyphens)",
        postCode: "Postal code",
        postCodeNoHyphen: "Postal code (no hyphens)",
        toyoshimaSalesDepartment: "Toyoshima Sales Department",
        toyoshimaSalesRepName: "Toyoshima sales rep",
        plannedSite: "Planned location",
        siteName: "Site name",
        email: "Email address",
        contactName: "Contact name",
        contactPosition: "Contact position",
        contact: "Primary contact",
        departmentName: "Department name",
        name: "Name",
        position: "Position",
        billingInfo: "Billing information",
        billingDepartment: "Billing contact department",
        contractPeriod: "Contract period",
        contractInfo: "Contract information",
        startDate: "Start date",
        endDate: "Expected contract end date",
        amount: "Contract amount",
        memo: "Company memo",
        departmentMemo: "Department memo",
        brandName: "Brand name",
        selectCompany: "Select a company",
        listPage: "Company list",
        registerPage: "Register company",
        editPage: "Edit company",
        departmentRegister: "Add departments",
        departmentEdit: "Edit departments",
        totalCount: "Total companies: {{count}}",
        registerCompanyDepartment: "Register company and departments",
        deleteTarget: "Delete \"{{name}}\".",
        deleteConfirm: "This operation cannot be undone. Continue?",
        deleteOk: "Delete",
        departmentList: "Departments",
        departmentDetailPage: "Department details",
        departmentTotalCount: "Total departments: {{count}}",
        activeUserCount: "Active users: {{active}} / {{total}}",
        userList: "Users",
        addDepartment: "Add department",
        editCompanyDepartment: "Edit company and departments",
        departmentCsvBulkRegister: "Bulk register departments by CSV",
        userRegister: "Add user",
        userCsvBulkRegister: "Bulk add users by CSV",
        measurementResults: "Measurement results",
        deviceList: "Devices",
        measurementErrors: "Measurement errors",
        validation: {
          contactEmailRequired: "Enter the primary contact email address.",
          departmentRequired: "Enter the brand name and department name for each department.",
          phoneNumberDigits: "Enter phone numbers using digits only, with no hyphens.",
          emailInvalid: "Check the email address.",
          postCodeDigits: "Enter the postal code as 7 digits.",
        },
        messages: {
          duplicateDepartment: "This company already has a department with that name. Enter a different department name.",
          registerSucceeded: "Company registered.",
          updateSucceeded: "Company information updated.",
          saveFailed: "Failed to save company information.",
        },
      },
      device: {
        listPage: "Device list",
        companyListPage: "{{companyName}} device list",
        registerPage: "Add device",
        editPage: "Edit device",
        totalCount: "Total devices: {{count}}",
        registerNew: "Add new device",
        registerNewShort: "Add device",
        company: "Company",
        location: "Site",
        deviceName: "Device name",
        apiKey: "API Key",
        initialSettings: "Initial settings",
        createdDate: "Created on",
        updatedDate: "Updated on",
        selectCompany: "Select a company",
        deleteTarget: "Delete {{name}}",
        deleteConfirmStrict: "This operation cannot be undone. Continue?",
        deleteSucceeded: "Device deleted.",
        registerSucceeded: "Device added.",
        registerFailed: "Failed to add device.",
        updateSucceeded: "Device updated.",
        updateFailed: "Failed to update device.",
        requiredCompany: "Select a company.",
        requiredLocationAndName: "Site and device name are required.",
        regenerate: "Regenerate",
        regenerateConfirmTitle: "Regenerate API key?",
        regenerateConfirmContent: "The current API key will stop working immediately.",
        regenerateConfirmTitleWithContent: "Regenerating the API key will make the current API key stop working immediately.",
        regenerateConfirmQuestion: "Regenerate it?",
        regenerateFailed: "Failed to regenerate API key.",
        regenerateSucceeded: "API key regenerated.",
        unsavedChangesTitle: "There are unsaved changes.",
        saveAndRegenerateConfirm: "Save changes and regenerate the API key?",
        updateAndRegenerateSucceeded: "Device information updated and API key regenerated.",
        updateInfoFailed: "Failed to update device information.",
      },
      itemMaster: {
        title: "Item master",
        listPage: "Item master list",
        companyListPage: "{{companyName}} item master list",
        janCode: "JAN code",
        repeat: "Repeat",
        partNumber: "Part number",
        sampleNumber: "Sample No.",
        itemName: "Item name",
        brandName: "Brand name",
        size: "Size",
        colorNo: "Color No.",
        registerPage: "Add item master",
        editPage: "Edit item master",
        janCodeMatchExact: "Exact match",
        janCodeMatchPrefix: "Starts with",
        targetCompanySelect: "Select target company",
        required: "Required",
        companySelectDescription: "Selecting a company enables the list, registration, and CSV operations.",
        selectCompany: "Select a company",
        janCodeInput: "Enter a JAN code",
        searchHelp: "Search for JAN codes that match the input exactly or start with the input, depending on the search method.",
        partNumberSearchPlaceholder: "Search by part number",
        itemNameSearchPlaceholder: "Search by item name",
        brandNameSearchPlaceholder: "Search by brand name",
        clear: "Clear",
        totalCount: "Total items: {{count}}",
        companyNotSelected: "No target company selected",
        selectCompanyToDisplayItems: "Select a company to display its item list.",
        registerItem: "Add item",
        csvBulkRegister: "Bulk add items by CSV",
        showTotal: "Showing {{start}}-{{end}} of {{total}}",
        createdAt: "Created",
        updatedAt: "Last updated",
        deleteTarget: "Delete \"{{name}}\".",
        fallbackDeleteTarget: "Target item",
        deleteConfirm: "This operation cannot be undone. Continue?",
        deleteOk: "Delete",
        deleteSucceeded: "Item master deleted.",
        deleteFailed: "Failed to delete item master.",
        uploadSucceededWithCounts: "{{fileName}} uploaded successfully. Created: {{created}} / Updated: {{updated}}",
        companyIdMissing: "Company ID could not be obtained.",
        companyIdLabel: "Company ID: {{id}}",
        csvRegistrationError: "CSV registration error",
        uploadFailed: "Failed to upload {{fileName}}",
        validation: {
          janCodeDigitsOnly: "Enter the JAN code using digits only.",
          janCodeMaxLength: "Enter a JAN code with {{max}} digits or fewer.",
          janCodeRequired: "Enter the JAN code.",
          janCodeInvalidLength: "Enter the JAN code as 8 or 13 digits.",
          repeatNonNegativeInteger: "Enter a repeat value of 0 or greater.",
          partNumberRequired: "Enter the part number.",
          partNumberMaxLength: "Enter the part number using {{max}} characters or fewer.",
          sampleNumberMaxLength: "Enter the sample No. using {{max}} characters or fewer.",
          itemNameRequired: "Enter the item name.",
          itemNameMaxLength: "Enter the item name using {{max}} characters or fewer.",
          brandNameRequired: "Enter the brand name.",
          brandNameMaxLength: "Enter the brand name using {{max}} characters or fewer.",
          sizeMaxLength: "Enter the size using {{max}} characters or fewer.",
          colorNoRequired: "Enter the color No.",
          colorNoMaxLength: "Enter the color No. using {{max}} characters or fewer.",
        },
        messages: {
          duplicateJanCode: "An item master with the same JAN code already exists.",
          notFound: "The target item master was not found.",
          registerFailed: "Failed to register the item master.",
          updateFailed: "Failed to update the item master.",
          registerSucceeded: "Item master added.",
          updateSucceeded: "Item master updated.",
        },
      },
      messages: {
        registrationCompleted: "Registration complete.",
        confirmInput: "Please check your entries.",
        processFailed: "An error occurred while processing.",
        processFailedRetry: "An error occurred while processing. Please try again.",
        retry: "Please try again.",
        uploadSucceeded: "{{fileName}} uploaded successfully.",
        uploadFailed: "Failed to upload {{fileName}}",
        csvDownloadFailed: "CSV download failed.",
        csvUploadFailed: "CSV upload failed.",
      },
      errorCodes: {
        DEPARTMENT_NAME_DUPLICATED: "That department name already exists.",
        CONFLICT: "A matching record already exists.",
        VALIDATION_ERROR: "Please check your entries.",
        RESOURCE_NOT_FOUND: "The requested record was not found.",
        INTERNAL_SERVER_ERROR: "An error occurred while processing.",
        AUTH_API_KEY_MISSING: "API key is missing.",
        AUTH_INVALID_API_KEY: "API key is invalid.",
        AUTH_IP_NOT_ALLOWED: "Access from this IP address is not allowed.",
        RATE_LIMIT_EXCEEDED: "Too many requests. Please try again later.",
        PAYLOAD_TOO_LARGE: "The submitted data exceeds the size limit.",
        URI_TOO_LONG: "The URL is too long.",
      },
      departmentUser: {
        registerPage: "Add user",
        editPage: "Edit user",
        detailPage: "User details",
        adminRole: "Admin role",
        pin: "PIN",
        maskedPassword: "•••••••",
        createdDate: "Created on",
        lastLoginDate: "Last login",
        sampleStatsTitle: "Measurements by user",
        sampleCount: "{{count}} styles",
        total: "Total",
        messages: {
          emailAlreadyRegistered: "This email address is already registered.",
          authenticationFailed: "Authentication failed.",
          registerSucceeded: "User added.",
          updateSucceeded: "User information updated.",
          genericError: "An error occurred.",
        },
        reissue: {
          action: "Regenerate",
          confirmTitle: "Regenerate {{target}}?",
          confirmContent: "Regenerating this will invalidate the current {{target}}.",
          pinSuccessTitle: "PIN regenerated.",
          pinSuccessContent: "A new PIN code has been saved.",
          pinErrorTitle: "Failed to regenerate PIN.",
          passwordSuccessTitle: "Password regenerated.",
          passwordSuccessContent: "A new password has been saved.",
          passwordErrorTitle: "Failed to regenerate password.",
        },
      },
      pages: {
        homeBack: "Back to home",
        nameMatching: "Name matching management",
        measurementErrorList: "Measurement Error Settings",
      },
      csvImportTitles: {
        nameCollation: "Name collation CSV import",
        departments: "Department CSV import",
        users: "User CSV import",
        measurementError: "Brand tolerance CSV import",
        itemMaster: "Item master CSV import",
      },
      measurementError: {
        measurePoint: "Measurement point",
        settingError: "Tolerance",
        plus: "Plus",
        minus: "Minus",
      },
      reportLayout: {
        title: "Measurement Report Layouts",
        csvImportTitle: "Measurement report layout CSV import",
        identifier: "Identifier (clothetype)",
        layoutType: "Layout type (layout_type)",
        updatedAt: "Updated at",
        create: "Create",
        registerTitle: "Add layout setting",
        editTitle: "Edit layout setting",
        bottomsLayout: "1: Bottoms layout (left/right)",
        topsLayout: "2: Tops layout (top/bottom)",
        otherLayout: "3: Other",
        fetchFailed: "Failed to load measurement report layout records.",
        saveFailed: "Save failed.",
        saveSucceeded: "Saved.",
        deleteConfirmTitle: "Delete confirmation",
        deleteConfirmContent: "Delete the layout setting for {{name}}.",
        deleteFailed: "Delete failed.",
        deleteSucceeded: "Deleted.",
        csvUploadSucceeded: "CSV imported.",
        csvErrors: {
          title: "CSV import error",
          row: "Row {{rowNumber}}: {{message}}",
          uploadFailed: "Failed to upload {{fileName}}.",
          codes: {
            HEADER_MISSING: "Required columns are missing from the CSV header.",
            HEADER_INVALID: "The CSV header contains unsupported columns.",
            EMPTY_DATA: "The CSV contains no data rows.",
            MISSING_REQUIRED_FIELDS: "Enter the required clothtype and layout_type values.",
            INVALID_CLOTHTYPE: "The clothtype value is invalid. Check its length and first character.",
            INVALID_LAYOUT_TYPE: "Set layout_type to 1, 2, or 3.",
            DUPLICATE_CLOTHTYPE: "The CSV contains duplicate clothtype values.",
            CSV_INVALID_RECORD_LENGTH: "The number of columns is inconsistent between CSV rows.",
            FILE_REQUIRED: "Select a CSV file.",
            FILE_EXTENSION_INVALID: "Select a file with the .csv extension.",
          },
        },
        validation: {
          identifierRequired: "Enter the identifier.",
          maxLength: "Enter {{max}} characters or fewer.",
          noControlCharacters: "Control characters cannot be used.",
          noCsvFormulaPrefix: "The first character cannot be =, +, -, or @.",
          layoutTypeRequired: "Select a layout type.",
        },
      },
      measurements: {
        listPage: "{{companyName}} measurement results",
        all: "All",
        filled: "Entered",
        unfilled: "Not entered",
        notEntered: "Not entered",
        selectedCount: "{{count}} selected",
        clearSelection: "Clear selection",
        selectAll: "Select all",
        deleteSelected: "Delete selected items",
        exportSelectedCsv: "Export selected items to CSV",
        showTotal: "Showing {{start}}-{{end}} of {{total}}",
        thumbnail: "Thumbnail",
        measuredAt: "Measured at",
        openUrlNewTab: "Open URL in a new tab",
        recorder: "Recorder",
        type: "Type",
        sample: "Sample",
        final: "Production",
        measurement: "Measurement",
        outputError: "Export error",
        invalidSelection: "No valid samples are selected.",
        exportLimitExceeded: "You can export up to {{count}} measurement results at once.",
        exportFailed: "CSV export failed.",
        deleteFailedRetry: "Delete failed. Please try again later.",
        deleteReason: {
          label: "Delete reason (optional)",
          selectPlaceholder: "Select a delete reason",
          freeTextPlaceholder: "Enter a delete reason (optional)",
          presets: {
            顧客要望: "Customer request",
            内部ミス削除: "Internal error",
            データ不備: "Data issue",
            その他: "Other",
          },
        },
        deleteConfirmTitle: "Delete confirmation",
        deleteOk: "Delete",
        bulkDeleteConfirm: "Delete {{count}} selected items. This cannot be undone. Continue?",
        singleDeleteConfirm: "Delete this measurement result. This cannot be undone. Continue?",
      },
    } as const;
